export default __webpack_public_path__ + "static/media/SportsIllustratedLogo.e904ceb3.svg";